import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import ServiceDetailsHeader from "../components/Common/ImageHeader";
import StrategicPartnershipsSection from "../components/ClientPartner/PartnerDescription";
import ClientsSection from "../components/Common/ClientSection";
import Feedback from "../components/Common/Feedback";
import { homePageTestimonialConfig } from "../components/Common/DifferentFeedbackConfig";
import { clientFeedbackService, formatClientFeedbackData } from "../services/clientFeedbackService";
import { clientPartnerService, formatClientPartnerData } from "../services/clientPartnerService";

const OurCulture = () => {
  const navigate = useNavigate();
  const [testimonials, setTestimonials] = useState([]);
  const [clientPartnerData, setClientPartnerData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch client partner page data
        const clientPartnerResponse = await clientPartnerService.getClientPartnerData();
        if (clientPartnerResponse.success && clientPartnerResponse.data) {
          const formattedData = formatClientPartnerData(clientPartnerResponse.data);
          setClientPartnerData(formattedData);
        }

        // Fetch testimonials
        const feedbackResponse = await clientFeedbackService.getClientFeedback();
        if (feedbackResponse.success && feedbackResponse.data) {
          const formattedTestimonials = formatClientFeedbackData(feedbackResponse.data);
          setTestimonials(formattedTestimonials);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleBreadcrumbClick = (href) => {
    if (href && href !== "#") {
      navigate(href);
    }
  };

  // Show loading or error state if no data
  if (loading) {
    return <div>Loading...</div>;
  }

  if (!clientPartnerData) {
    return <div>Error loading client partner data</div>;
  }

  return (
    <>
      {/* <ServiceDetailsHeader
        title={clientPartnerData.clientHeader?.title}
        subtitle={clientPartnerData.clientHeader?.description}
        backgroundImage={clientPartnerData.clientHeader?.headerImage?.url || "/png/client-partner.png"}
        breadcrumbItems={[
          { label: "Home", href: "/" },
          { label: "Client & Partner", href: "#", isCurrentPage: true },
        ]}
        onBreadcrumbClick={handleBreadcrumbClick}
      /> */}
      <div
        style={{
          backgroundImage: "url(/png/background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <StrategicPartnershipsSection data={clientPartnerData?.titleDesc} />
        <ClientsSection clientSections={clientPartnerData?.clientSections} />
        {/* <Feedback
          testimonials={testimonials}
          config={homePageTestimonialConfig}
        /> */}
      </div>
    </>
  );
};

export default OurCulture;
